export const gamesImage = '/static/images/games_left_yes.svg';

export const gamesZeroImage = '/static/images/games_left_no.svg';

export const pointsImage = '/static/images/modals/levelup/points_1.svg';

export const lockedImage = '/static/images/locked.svg';

export const unlockedImage = '/static/images/unlocked.svg';

export const bundleDiscountImage = '/static/images/notifications/discount.svg';

export const inviteImage = '/static/images/invite_friends_icon.svg';

export const puzzleBonusGameImage = '/static/images/notifications/puzzle.svg';

export const lanternsBonusGameImage = '/static/images/notifications/lanterns.svg';
